<div class="buttons-container">
  <button>
    <svg width="19" height="19" viewBox="0 0 18 13">
      <path
        fill="#879BAF"
        fill-rule="evenodd"
        d="M9 13.945l-3.996-3.267V4.332L9 1.064v12.881zM4 11H1V4l3 .02V11zM9.56.12c.28.158.447.442.447.76v13.252a.862.862 0 0 1-.447.757.912.912 0 0 1-.899.002l-3.848-3.108a.68.68 0 0 1-.497.218H.688a.69.69 0 0 1-.688-.69V3.684c0-.38.309-.688.688-.688h3.628c.2 0 .376.09.502.225L8.66.12a.91.91 0 0 1 .9.001zM14.5 7.5c0 1.654-1.346 3-3 3v-1c1.103 0 2-.897 2-2s-.897-2-2-2v-1c1.654 0 3 1.346 3 3zm-3-6c3.309 0 6 2.691 6 6s-2.691 6-6 6v-1c2.757 0 5-2.243 5-5s-2.243-5-5-5v-1z"
      />
    </svg>
  </button>
  <button>
    <svg width="19" height="16" viewBox="0 0 19 16">
      <path
        fill="#BDCBD8"
        fill-rule="evenodd"
        d="M5 9V6h1v3H5zm8 0V6h1.001v3H13zM9 9V6h1v3H9zm2 1V5.001h1V10h-1zm-4 0V5.001h1V10H7zm10.5-1.5c.827 0 1.5.673 1.5 1.5v4.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5v-7C16 3.916 13.084 1 9.5 1A6.508 6.508 0 0 0 3 7.5v7c0 .827-.673 1.5-1.5 1.5S0 15.327 0 14.5V10c0-.827.673-1.5 1.5-1.5.176 0 .343.036.5.092V7.5C2 3.364 5.364 0 9.5 0S17 3.364 17 7.5v1.092c.157-.056.324-.092.5-.092zm.5 6V10c0-.275-.225-.5-.5-.5s-.5.225-.5.5v4.5c0 .275.225.5.5.5s.5-.225.5-.5zm-16 0V10c0-.275-.225-.5-.5-.5s-.5.225-.5.5v4.5c0 .275.225.5.5.5s.5-.225.5-.5z"
      />
    </svg>
  </button>
</div>
<div class="sound-indicator-container">
  <div class="decibel-row">
    <i>-72</i>
    <i>-60</i>
    <i>-48</i>
    <i>-36</i>
    <i>-24</i>
    <i>-10</i>
    <i>0</i>
  </div>
  <div class="decibel-bar-row">
    <span>L</span>
    <div>
      <soundbar></soundbar>
    </div>
  </div>
  <div class="decibel-bar-row">
    <span>R</span>
    <div>
      <soundbar></soundbar>
    </div>
  </div>
  <div class="decibel-slider-row">
    <span>0 DB</span>
  </div>
</div>
